import { setDependentAnswerPreset, setDirectAnswerPreset } from "../..";
import { GLOBAL_PRESETS } from "../presets";
import { TAnswerFlow } from "../types";
import * as beautyUtils from "../utils";

export const SKINCARE_ANSWER_FLOWS: Record<number, TAnswerFlow> = {
  1: setDirectAnswerPreset(
    undefined,
    "Thayers Skin Care Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Thayers Skin Care category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].skincare.thayers_oos_before()
  ),
  2: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of Thayers Skin Care products you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].skincare.thayers_stocked()
  ),
  3: setDependentAnswerPreset(
    undefined,
    "Thayers Skin Care: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [1],
    beautyUtils.getAfterOOSCount
  ),

  4: setDirectAnswerPreset(
    undefined,
    "L'Oreal Skin Care Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the L'Oreal Skin Care category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].skincare.loreal_oos_before()
  ),
  5: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of L'Oreal Skin Care products you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].skincare.loreal_stocked()
  ),
  6: setDependentAnswerPreset(
    undefined,
    "L'Oreal Skin Care: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [4],
    beautyUtils.getAfterOOSCount
  ),

  7: setDirectAnswerPreset(
    undefined,
    "Garnier Skin Care Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Garnier Skin Care category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].skincare.garnier_oos_before()
  ),
  8: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of Thayers Skin Care products you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].skincare.garnier_stocked()
  ),
  9: setDependentAnswerPreset(
    undefined,
    "Garnier Skin Care: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [7],
    beautyUtils.getAfterOOSCount
  ),

  10: setDependentAnswerPreset(
    undefined,
    "Thayers Skin Care: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [3],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  11: setDependentAnswerPreset(
    undefined,
    "L'Oreal Skin Care: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [6],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  12: setDependentAnswerPreset(
    undefined,
    "Garnier Skin Care: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [9],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),

  13: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of Garnier Skin Care products you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].skincare.garnier_stocked()
  ),

  14: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of Garnier Skin Care products you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].skincare.garnier_stocked()
  ),

  15: setDependentAnswerPreset(
    undefined,
    "Thayers Skin Care: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [10],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  16: setDependentAnswerPreset(
    undefined,
    "L'Oreal Skin Care: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [11],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  17: setDependentAnswerPreset(
    undefined,
    "Garnier Skin Care: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [12],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  18: setDependentAnswerPreset(
    undefined,
    "Did a Team Lead assist you during your service to correct any Skin Care",
    "radio",
    [10, 11, 12],
    beautyUtils.getDidATeamMemberAssistYouWithUpdatingOnHands
  ),
};
